import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import ClientsContent from "../ones/ClientsContent";
import Footer from "../ones/Footer";
import CallToAction from "../ones/CallToAction";

export default function ClientsLanding() {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <ClientsContent />
        <CallToAction />
        <Footer />
      </>
    );
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
